export default "__VITE_ASSET__fc8iRe7A__"